import { FileTypeCount } from "../types";

/** Microsoft Office mime types that are previewed via the Google Docs viewer. */
export const OFFICE_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

/** Friendly display labels keyed by mime type. */
export const FRIENDLY_TYPE_MAP: Record<string, string> = {
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel",
  "application/vnd.ms-excel": "Excel (Legacy)",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "Word",
  "application/msword": "Word (Legacy)",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    "PowerPoint",
  "application/vnd.ms-powerpoint": "PowerPoint (Legacy)",
  "application/pdf": "PDF",
  "image/jpeg": "JPEG Image",
  "image/png": "PNG Image",
  "image/gif": "GIF Image",
  "video/mp4": "MP4 Video",
  "video/quicktime": "QuickTime Video",
  "audio/mpeg": "MP3 Audio",
  "text/plain": "Text File",
  "text/csv": "CSV File",
  "application/json": "JSON File",
  // Add more mappings as needed
};

/** A zeroed file-type count, used as initial state and as a safe fallback. */
export const EMPTY_FILE_COUNT: FileTypeCount = {
  folder: 0,
  image: 0,
  video: 0,
  pdf: 0,
  other: 0,
};
